module.exports = __webpack_public_path__ + "img/home.3ceb820c.svg";